import { useEffect, useMemo, useRef, useState } from "preact/hooks";
import { low_res_placeholder } from "../settings";
import { useController } from "../helpers";

export const LowResImage = ({ image, index, isPreparing }) => {
  // Image reference for the low-resolution image
  const ref = useRef();

  // Destructuring methods from the controller
  const { onContextMenu } = useController();

  // State to track if the image has been styled
  const [ styled, setStyled ] = useState(false);

  // Memoized boolean to check if the image needs preparation based on certain conditions
  const needsPreparing = useMemo(
    () => low_res_placeholder && image.dimensions.width && image.dimensions.height && isPreparing,
    [image, isPreparing]
  );

  // Effect to set the source of the image if it needs preparation
  useEffect(() => {
    if (ref.current?.src || !ref.current || !needsPreparing) {
      return;
    }

    const newSrc = image.low_res_src ?? document.querySelector(`.mwl-img[mwl-index="${index}"]`).currentSrc;
    ref.current.setAttribute('src', newSrc);
  }, [image, index, needsPreparing]);

  // Effect to adjust the styling of the image based on its dimensions and container dimensions
  useEffect(() => {
    if (!ref.current || styled) {
      return;
    }

    if (!needsPreparing) {
      Object.assign(ref.current.style, {
        maxHeight: 'none',
        maxWidth: 'none',
        height: 'auto',
        width: 'auto'
      });
      return;
    };

    const { height, width } = image.dimensions;
    const container = ref.current.parentNode;
    const imageRatio = width / height;
    const containerRatio = container.offsetWidth / container.offsetHeight;

    const newStyle = (imageRatio < containerRatio) ? {
      maxHeight: `${height}px`,
      maxWidth: `${width}px`,
      width: 'auto',
      height: '100%'
    } : {
      maxHeight: `${height}px`,
      maxWidth: `${width}px`,
      width: '100%',
      height: 'auto'
    };

    Object.assign(ref.current.style, newStyle);
    setStyled(true);
  }, [styled, image, needsPreparing]);

  return (
    <img
      ref={ref}
      className="mwl__slider__image__thumbnail__low-res"
      data-src={image.low_res_src ?? ""}
      onContextMenu={onContextMenu}
      alt={image.title}
    />
  );
};
